export default {
  data() {
    return {
      curPage: 1,
      pageSize: 20,
      total: 0,
    }
  },

  computed: {
    curPageStart() {
      const { curPage, pageSize, total } = this
      if (total === 0) return 0

      return (curPage - 1) * pageSize + 1
    },

    curPageEnd() {
      const { curPage, pageSize, total } = this
      if (total === 0) return 0

      const pageEnd = curPage * pageSize
      return pageEnd > total ? total : pageEnd
    },
  },

  created() {
    const pSize = localStorage.getItem('pSize')
    this.pageSize = pSize && Number(pSize) ? Number(pSize) : 20
  },

  methods: {
    pageChange(page) {
      this.curPage = page
      this.refresh()
    },

    onPageSizeChange(pageSize) {
      if (this.curPage !== 1) {
        this.curPage = 1
      }
      this.pageSize = pageSize
      localStorage.setItem('pSize', pageSize)
      this.refresh()
    },
  },
}
